import { DOMAIN } from '../config';
import { getSurveyCookie } from './surveyConfig';

export function clearSurveyCookie(country) {
    const { zohoSurveyCode } = getSurveyCookie(country);
    const cookiesToClear = [
        `zs_popup_${zohoSurveyCode}`,
        `zs_popup_${zohoSurveyCode}?az_mail`,
        `ZS_${zohoSurveyCode}`,
    ];

    cookiesToClear.forEach((name) => {
        document.cookie = [
            `${name}=`,
            `Path=/`,
            `Domain=${DOMAIN}`,
            `Expires=Thu, 01 Jan 1970 00:00:00 GMT`,
        ].join('; ');
        document.cookie = [`${name}=`, `Path=/`, `Expires=Thu, 01 Jan 1970 00:00:00 GMT`].join(
            '; ',
        );
    });
}
